import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import OfficeBankTable from "./view/OfficeBankTable";

export const OfficeBank = () => {
  const viewBank =
    PERMISSIONS.permission_utilities_officeconfiguration_officebank_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewBank) && < OfficeBankTable/>}</>;
};

export default OfficeBank;
